import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { UserContext } from '../../Context/UserContext';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RewardListPage = () => {
  const { baseUrl, getHeaders, user } = useContext(UserContext);
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showStatusConfirm, setShowStatusConfirm] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    setLoading(true);
    try {
      const active_company = localStorage.getItem('active_company') || user?.company_name;
      const active_branch = localStorage.getItem('active_branch') || user?.branch_name;

      const response = await axios.get(`${baseUrl}/api/reward-rules`, {
        headers: getHeaders(active_branch, active_company)
      });

      if (response.data) {
        setRewards(response.data);
      }
    } catch (error) {
      console.error("Error fetching rewards:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this reward rule?")) return;

    try {
      const active_company = localStorage.getItem('active_company') || user?.company_name;
      const active_branch = localStorage.getItem('active_branch') || user?.branch_name;

      await axios.delete(`${baseUrl}/api/reward-rules/${id}`, {
        headers: getHeaders(active_branch, active_company)
      });

      toast.success("Reward deleted successfully");
      fetchRewards();
    } catch (error) {
      console.error("Error deleting reward:", error);
      toast.error("Failed to delete reward");
    }
  };

  const handleEdit = (reward) => {
    navigate('/create-reward', { state: { reward } });
  };

  const handleToggleStatus = (reward) => {
    setShowStatusConfirm(reward);
  };

  const confirmToggleStatus = async () => {
    if (!showStatusConfirm) return;
    
    const reward = showStatusConfirm;
    const newStatus = !reward.is_active;

    try {
      const active_company = localStorage.getItem('active_company') || user?.company_name;
      const active_branch = localStorage.getItem('active_branch') || user?.branch_name;

      await axios.put(`${baseUrl}/api/reward-rules/${reward.id || reward._id}`, {
        is_active: newStatus
      }, {
        headers: getHeaders(active_branch, active_company)
      });

      toast.success(`Reward status updated to ${newStatus ? 'Active' : 'Inactive'}`);
      setShowStatusConfirm(null);
      fetchRewards();
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status");
      setShowStatusConfirm(null);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'var(--ap-font-family, sans-serif)' }}>
      <ToastContainer />
      <style>{`
        .premium-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
        }
        .premium-table th {
          background: #06D6A0;
          color: #ffffff;
          font-weight: 600;
          font-size: 15px;
          text-transform: capitalize;
          padding: 16px 24px;
          text-align: left;
        }
        .premium-table th:first-child {
          border-top-left-radius: 10px;
        }
        .premium-table th:last-child {
          border-top-right-radius: 10px;
        }
        .premium-table td {
          padding: 16px 24px;
          color: #4A4A5A;
          font-size: 14px;
          font-weight: 500;
          border-bottom: 1px solid #F1F3F8;
          transition: all 0.2s ease;
          vertical-align: middle;
        }
        .premium-table tr:nth-child(odd) td {
          background: #ffffff;
        }
        .premium-table tr:nth-child(even) td {
          background: #FAFBFD;
        }
        .premium-table tr:hover td {
          background: #F1F4F9;
        }
        .premium-table tr:last-child td {
          border-bottom: none;
        }
        .action-btn {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s;
          background: transparent;
        }
        .action-btn:hover {
          transform: translateY(-2px);
        }
        .edit-btn:hover {
          background: #EBF0FF;
          color: #604BE8 !important;
        }
        .delete-btn:hover {
          background: #FEE2E2;
          color: #DC2626 !important;
        }
      `}</style>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', position: 'relative', padding: '10px 0' }}>
        <button
          onClick={() => navigate('/admin')}
          style={{ 
            padding: '10px 20px', 
            border: '1px solid #E5E7EB', 
            borderRadius: '24px', 
            background: '#ffffff', 
            color: '#3B82F6',
            fontWeight: '600',
            fontSize: '14px',
            cursor: 'pointer', 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
          }}
        >
          <i className="fas fa-arrow-left" style={{ fontSize: '12px' }}></i> Back to Admin
        </button>
        
        <h2 style={{ 
          color: '#111827', 
          margin: 0, 
          fontSize: '24px', 
          fontWeight: '700',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)'
        }}>
          Reward Rules
        </h2>
        
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => navigate('/create-reward')}
            style={{
              backgroundColor: '#604BE8',
              color: 'white',
              padding: '10px 24px',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontWeight: '600',
              fontSize: '14px',
              boxShadow: '0 4px 12px rgba(96, 75, 232, 0.2)'
            }}
          >
            <FaPlus size={12} /> Create Reward Rule
          </button>
        </div>
      </div>

      <div style={{ backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
        <table className="premium-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Applies To</th>
              <th>Target</th>
              <th>Spend Amount</th>
              <th>Points</th>
              <th>Schedule / Validity</th>
              <th>Company</th>
              <th>Branch</th>
              <th>Status</th>
              <th style={{ textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center' }}>Loading...</td>
              </tr>
            ) : rewards.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center' }}>No reward rules found. Create one to get started!</td>
              </tr>
            ) : (
              rewards.map((reward) => (
                <tr key={reward.id || reward._id}>
                  <td style={{ fontWeight: 'bold' }}>{reward.reward_name}</td>
                  <td>
                    <span style={{
                      display: 'inline-block',
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '700',
                      textTransform: 'capitalize',
                      background: reward.applies_to === 'offer' ? '#f0fdf4' : reward.applies_to === 'generally' ? '#eff6ff' : reward.applies_to === 'product' ? '#fdf4ff' : '#fff7ed',
                      color: reward.applies_to === 'offer' ? '#059669' : reward.applies_to === 'generally' ? '#2563eb' : reward.applies_to === 'product' ? '#9333ea' : '#ea580c',
                      border: `1px solid ${reward.applies_to === 'offer' ? '#6ee7b7' : reward.applies_to === 'generally' ? '#bfdbfe' : reward.applies_to === 'product' ? '#e9d5ff' : '#fed7aa'}`,
                    }}>
                      {reward.applies_to === 'offer' ? '🎁 Offer' : reward.applies_to === 'generally' ? '🌐 All Items' : reward.applies_to === 'product' ? '📦 Product' : reward.applies_to === 'group' ? '📂 Item Group' : reward.applies_to === 'subgroup' ? '📑 Subgroup' : reward.applies_to}
                    </span>
                  </td>
                  <td>
                    {reward.applies_to === 'group' && reward.group_name}
                    {reward.applies_to === 'subgroup' && reward.subgroup_name}
                    {(reward.applies_to === 'product' || reward.applies_to === 'offer') && reward.product_name}
                    {reward.applies_to === 'generally' && <span style={{ color: '#059669', fontWeight: '600' }}>All Items (Cart)</span>}
                  </td>
                  <td style={{ color: reward.applies_to === 'offer' ? '#94a3b8' : 'inherit', fontStyle: reward.applies_to === 'offer' ? 'italic' : 'normal' }}>
                    {reward.applies_to === 'offer' ? '—' : reward.amount_spent}
                  </td>
                  <td>
                    <span style={{ color: '#059669', fontWeight: 'bold', fontSize: '15px' }}>{reward.points_awarded}</span>
                    <span style={{ color: '#64748b', fontSize: '12px', fontWeight: '500', marginLeft: '4px' }}>
                      {reward.applies_to === 'offer' ? 'pts / offer' : 'pts'}
                    </span>
                  </td>
                  <td>
                    {!reward.has_time_limit ? (
                      <span style={{
                        display: 'inline-block',
                        padding: '3px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: '600',
                        background: '#f1f5f9',
                        color: '#475569'
                      }}>
                        ⚡ Always Active
                      </span>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '11px' }}>
                        {(reward.start_date || reward.end_date) && (
                          <span style={{ color: '#334155', fontWeight: '600' }}>
                            📅 {reward.start_date || 'Start'} → {reward.end_date || 'End'}
                          </span>
                        )}
                        {(reward.start_time || reward.end_time) && (
                          <span style={{ color: '#7c3aed', fontWeight: '600' }}>
                            ⏰ {reward.start_time || '00:00'} - {reward.end_time || '23:59'}
                          </span>
                        )}
                        {Array.isArray(reward.days_of_week) && reward.days_of_week.length < 7 && (
                          <span style={{ color: '#64748b' }}>
                            🗓️ {reward.days_of_week.map(d => d.slice(0, 3)).join(', ')}
                          </span>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    <span style={{ fontWeight: '500' }}>
                      {Array.isArray(reward.company_names) ? reward.company_names.join(', ') : reward.company_name || 'All'}
                    </span>
                  </td>
                  <td>
                    {(() => {
                      const branchText = Array.isArray(reward.branch_names) ? reward.branch_names.join(', ') : reward.branch_name;
                      const isCompanyWide = !branchText || branchText === 'All Branches' || branchText === 'All';
                      return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                          <span style={{
                            display: 'inline-block',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '11px',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            background: isCompanyWide ? '#e0e7ff' : '#dcfce7',
                            color: isCompanyWide ? '#3730a3' : '#166534',
                            width: 'fit-content'
                          }}>
                            {isCompanyWide ? '🏢 Company Scope' : '📍 Branch Scope'}
                          </span>
                          <span style={{ fontSize: '13px', color: '#475569' }}>
                            {isCompanyWide ? 'All Branches' : branchText}
                          </span>
                        </div>
                      );
                    })()}
                  </td>
                  <td>
                    <span 
                      onClick={() => handleToggleStatus(reward)}
                      style={{
                        padding: '6px 12px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        backgroundColor: reward.is_active ? '#d1fae5' : '#fee2e2',
                        color: reward.is_active ? '#065f46' : '#991b1b',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        display: 'inline-block',
                        transition: 'transform 0.2s',
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                      title={`Click to mark as ${reward.is_active ? 'Inactive' : 'Active'}`}
                    >
                      {reward.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                      <button
                        onClick={() => handleEdit(reward)}
                        className="action-btn edit-btn"
                        style={{ color: '#64748B' }}
                        title="Edit"
                      >
                        <FaEdit size={18} />
                      </button>
                      <button
                        onClick={() => handleDelete(reward.id || reward._id)}
                        className="action-btn delete-btn"
                        style={{ color: '#64748B' }}
                        title="Delete"
                      >
                        <FaTrash size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Custom Warning Modal for Status Toggle */}
      {showStatusConfirm && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(27, 27, 41, 0.5)', display: 'flex', justifyContent: 'center',
          alignItems: 'center', zIndex: 10001, backdropFilter: 'blur(8px)'
        }}>
          <div style={{
            backgroundColor: '#ffffff', borderRadius: '20px', width: '420px', maxWidth: '90%',
            padding: '36px', boxShadow: '0 20px 50px rgba(0, 0, 0, 0.2)',
            textAlign: 'center', animation: 'fadeInScale 0.3s ease-out', color: '#1B1B29'
          }}>
            <div style={{ width: '70px', height: '70px', background: '#fffbeb', color: '#f59e0b', borderRadius: '18px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '32px', margin: '0 auto 20px' }}>
              ⚠️
            </div>
            <h3 style={{ color: '#1B1B29', fontSize: '22px', fontWeight: '700', marginBottom: '10px' }}>
              Change Status?
            </h3>
            <p style={{ color: '#777777', fontSize: '15px', marginBottom: '30px', lineHeight: '1.6', fontWeight: '500' }}>
              Are you sure you want to change the status of <strong>{showStatusConfirm.reward_name}</strong> to <strong style={{ color: !showStatusConfirm.is_active ? '#059669' : '#dc2626' }}>{!showStatusConfirm.is_active ? 'Active' : 'Inactive'}</strong>?
            </p>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button 
                onClick={() => setShowStatusConfirm(null)} 
                style={{ flex: 1, padding: '14px', borderRadius: '10px', border: '1px solid #E2E6EF', background: '#ffffff', color: '#1B1B29', fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button 
                onClick={confirmToggleStatus} 
                style={{ flex: 1, padding: '14px', borderRadius: '10px', border: 'none', background: '#f59e0b', color: '#ffffff', fontWeight: '600', fontSize: '14px', cursor: 'pointer', boxShadow: '0 4px 15px rgba(245, 158, 11, 0.3)' }}
              >
                Yes, Change it
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RewardListPage;
